// schedule.js
import * as types from "../types_schedule";
import axios from "axios";
import authHeader from "../../authHeader";

const state = {
  schedules: {
    isLoading: false,
    isError: false,
    data: [],
  },
};

const getters = {
  schedulesData: (state) => {
    return state.schedules.data;
  },
};

const actions = {
  addSchedule: (context, payload) => {
    return new Promise((resolve, reject) => {
      let headers = authHeader();
      // console.log("Headers:", headers);
      axios({
        method: "POST",
        url: "/schedule/addschedule", // Update the URL to your API endpoint
        data: payload,
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          // Update the state or handle the response if necessary
          // console.log(res);
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Failed to add schedule."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  setScheduleData: (context) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: "/schedule/getschedules",
        headers: authHeader(),
      })
        .then((res) => {
          context.state.schedules.data = res.data;
          resolve("Success");
        })
        .catch((error) => {
          context.state.schedules.isLoading = false;
          context.state.schedules.isError = true;
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Failed to load schedules."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule.js